import { render } from "./TheatreDetail.vue?vue&type=template&id=37404f9a"
import script from "./TheatreDetail.vue?vue&type=script&lang=js"
export * from "./TheatreDetail.vue?vue&type=script&lang=js"

import "./TheatreDetail.vue?vue&type=style&index=0&id=37404f9a&lang=css"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__